
import api from '@/api/proxyWeb/budgets'
import { getFromLocation } from '@/api/proxyWeb/api'

export default {

    add({ commit }, budget) {

        return new Promise((resolve, reject) => {
        
            api.post(budget)
                .then( response => {                    
                    
                    getFromLocation(response.headers.location)
                        .then( budget => {
                            resolve(budget)
                            commit('addBudget', budget)
                        })
                        .catch(error => reject(error))
                })
                .catch(error => reject(error))
            });
    },

    get({ commit }, id) {

        commit('setCurrentBudget', null)

        return new Promise(resolve => {
        
            api.get(id)
                .then(budget => {
                    commit('setCurrentBudget', budget)
                    resolve(budget)
                })
            });
    },

    getAll({ commit }) {

        commit('setBudgets', null)

        return new Promise(resolve => {
        
            Promise.all([
                api.count(),
                api.list()
            ])
            .then( ([ count, budgets ]) => {
                commit('setCount', count)
                commit('setBudgets', budgets)
                resolve(budgets)
            })
        })
    },

    getNext({ commit, state }) {

        let params = {
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(budgets => {
                commit('setNextBudgets', budgets)
            })
    },

    update({ commit }, budget) {

        return api.patch(budget)
            .then( () => commit('updateBudget', budget) )
    }
}